export const IMGIX_BASE_URL = 'https://idagio-images.global.ssl.fastly.net';

// Centrally declare all parameter variants we use anywhere in the app
// (without the dimensions, no h, w or dpr here!)
export const IMGIX_STYLE_1 = { fit: 'crop', crop: 'faces' };
export const IMGIX_STYLE_2 = { fit: 'crop' };
export const IMGIX_STYLE_3 = { blur: '50' };
export const IMGIX_STYLE_4 = { fit: 'fill', fill: 'blur' };

// Image size buckets
// Top-n by number of hits as found in our CDN Logs between 2025-11-05 and 2025-11-09
// Note: if you change this, don't forget to update the image urls in css files as well (e.g. global.css)
const IMG_SIZES = [
  ...new Set([44, 47, 48, 56, 88, 96, 112, 128, 144, 168, 320, 432, 750, 1180, 1366, 1600]),
].sort((a, b) => a - b);

export const PROFILE_IMAGE_PREVIEW_DIMS = { w: 48, h: 48 };
export const SEARCH_IMAGE_DIMS = { w: 96, h: 96 };
export const PROFILE_IMAGE_DIMS = { w: 150, h: 150 };
export const PLAYABLE_ITEM_PREVIEW_DIMS = { w: 400, h: 400 };
export const PLAYABLE_ITEM_FULL_DIMS = { w: 720, h: 720 };
export const LIVESTREAM_EVENT_IMAGE_DIMS = { w: 750, h: 375 };

export function quantizedPixelSize(px) {
  for (const b of IMG_SIZES) {
    if (px <= b) return b;
  }
  return IMG_SIZES[IMG_SIZES.length - 1];
}

function imgixImageParams({
  style,
  width,
  height,
  dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1,
}) {
  const wPx = quantizedPixelSize(width * dpr);
  const hPx = quantizedPixelSize(height * dpr);
  const params = new URLSearchParams();

  if (style) {
    Object.entries(style).forEach(([key, value]) => {
      params.set(key, String(value));
    });
  }

  params.set('w', String(wPx));
  params.set('h', String(hPx));

  return params;
}

// Image URL builder function: Use this for all images
export function imgixImageUrl({ path, style, width, height, dpr }) {
  const params = imgixImageParams({ style, width, height, dpr });
  const url = new URL(path, IMGIX_BASE_URL);

  params.forEach((value, key) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
}
